var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2155 1.44342C11.5229 1.72105 11.5471 2.19531 11.2694 2.50271L9.81408 4.11408C10.4953 3.98086 11.2232 3.90167 12 3.90167C17.3602 3.90167 21.75 8.09349 21.75 13.3258C21.75 18.5582 17.3602 22.75 12 22.75C6.63978 22.75 2.25 18.5582 2.25 13.3258C2.25 11.3849 2.86144 9.5765 3.89875 8.07686C4.13439 7.7362 4.60157 7.65107 4.94223 7.8867C5.28289 8.12234 5.36802 8.58952 5.13239 8.93018C4.25967 10.1919 3.75 11.705 3.75 13.3258C3.75 17.6781 7.41559 21.25 12 21.25C16.5844 21.25 20.25 17.6781 20.25 13.3258C20.25 8.97358 16.5844 5.40167 12 5.40167C11.1201 5.40167 10.3106 5.51867 9.56332 5.7066L11.6427 7.16972C11.9815 7.40808 12.0628 7.87593 11.8245 8.21469C11.5861 8.55345 11.1183 8.63483 10.7795 8.39647L7.28125 5.93498C7.10563 5.81141 6.9914 5.61848 6.9675 5.40508C6.9436 5.19167 7.01232 4.97826 7.15625 4.8189L10.1563 1.49731C10.4339 1.18991 10.9081 1.16578 11.2155 1.44342Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerArrow);
export default __webpack_public_path__ + "static/media/spinner-arrow.6db56845ac4fb6293510bb9e27470603.svg";
export { ForwardRef as ReactComponent };